let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c6Wov")).then(() => parcelRequire('k3RNF'));